import React, { useMemo } from 'react';
import { ITextProps, Text } from '@fluentui/react';

export enum BwjTextSize {
  tiny = 'tiny',
  xSmall = 'xSmall',
  small = 'small',
  smallPlus = 'smallPlus',
  medium = 'medium',
  mediumPlus = 'mediumPlus',
  large = 'large',
  xLarge = 'xLarge',
  xxLarge = 'xxLarge',
  superLarge = 'superLarge',
  mega = 'mega',
}

interface IBwjTextProps extends ITextProps {
  textSize: BwjTextSize;
}

export const BwjText: React.FunctionComponent<IBwjTextProps> = (props) => {
  const txtProps = useMemo(() => {
    const tp = {...props};
    tp.variant = props.textSize;

    return tp as ITextProps;
  }, [props]);

  return (
    <Text {...txtProps} />
  );
};
